import requestor from "../../requestor";

export default class IntegrationApi {
  get = () => requestor.get("/project/integration_get");
  save = (form) => requestor.patch("/project/integration_save", form);
  createEdeoneApiKey = () => requestor.post("/project/create_api_token");
}
